import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgbTableComponent, Table } from '../ngb-table/ngb-table.component';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css'],
  imports: [NgbTableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportListComponent {
  readonly table = input<Table>();
}
